import { RcFile } from 'antd/lib/upload';
import type { ServiceInspectionFormValues } from '../components/Content';
import { SelectedServiceInspectionPayload, SelectedServiceInspectionPhotos } from '../types';

export const getServiceInspectionPayloadData = ({
  internalNote,
  registerStates,
}: ServiceInspectionFormValues): SelectedServiceInspectionPayload => ({
  service_inspection_date: new Date(),
  internal_note: internalNote ?? null,
  register_states: registerStates?.map(({ _id, unit, counter }) => ({ _id, unit, counter })) ?? [],
});

export const getServiceInspectionPayloadPhotos = ({
  registerStates,
  placementOverviewPhotos,
}: ServiceInspectionFormValues): SelectedServiceInspectionPhotos => ({
  placementOverviewPhotos: (placementOverviewPhotos ?? [])
    .map(photo => photo.originFileObj)
    .filter((f: RcFile | undefined): f is RcFile => Boolean(f)),
  registerPhotos: (registerStates ?? []).map(({ photos, _id }) => {
    return {
      _id,
      photos: (photos ?? [])
        .map(photo => photo.originFileObj)
        .filter((f: RcFile | undefined): f is RcFile => Boolean(f)),
    };
  }),
});
